export const detectLocale = (): string =>
  (navigator.languages && navigator.languages[0]) ||
  navigator.language || (navigator as any).userLanguage ||
  'en-US';

export const detectLanguage = (): string => detectLocale().split('-')[0];
